import { AnyAction } from 'redux';
import { App, BasisAdresse, Immobilie, RsVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';

export const risikoortReducer = function (
  sectionState: BasisAdresse = null,
  action: AnyAction,
): BasisAdresse {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      const immobilie: Immobilie = action.payload.immobilie as Immobilie;

      if (!immobilie || action.payload.appId !== App.RS_VERMIETUNG) {
        return sectionState;
      }

      const risikoort: BasisAdresse = immobilie.risikoort;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const risikoort: BasisAdresse = action.payload.versicherungsnehmer.adresse;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: RsVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.RS_VERMIETUNG) {
        return {
          ...sectionState,
          plz: actionPayload.vnAdresse?.plz,
          strasse: actionPayload.vnAdresse?.strasse,
          hausnummer: actionPayload.vnAdresse?.hausnummer,
          ort: actionPayload.vnAdresse?.ort,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
